<mat-dialog-content [ngClass.xs]="'w-mobile'" [ngClass.gt-xs]="'w-desktop'">
    <div class="thx-text">
        Do you really want to delete account?
    </div>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: space-between">
  <button mat-raised-button [color]="'danger'" mat-dialog-close>No</button>
  <button mat-raised-button [color]="'thx-exit'" mat-dialog-close (click)="deleteAccount()">Yes</button>
</mat-dialog-actions>
